export const accountViews = {
  botConfig: {
    breadcrumb: {
      listings: "Anúncios",
      current: "Agente de IA",
    },
    loading: "Carregando configuração...",
    retry: "Tentar novamente",
    loadError: "Erro ao carregar a configuração.",
    units: "{count} unidade | {count} unidades",
    faqsLabel: "FAQs",
    unitFallback: "Unidade",
    active: "Ativo",
    inactive: "Inativo",
    botWhatsapp: "Bot do WhatsApp",
    otaIa: "IA de OTA",
    saving: "Salvando...",
    cancel: "Cancelar",
    assistant: {
      title: "Assistente do WhatsApp",
      desc: "Ative o bot automático para responder aos seus hóspedes no WhatsApp.",
    },
    ota: {
      title: "IA de OTA",
      desc: "Responda automaticamente às mensagens do Booking.com, Airbnb e outras OTAs.",
      warn: "Ative primeiro o Assistente do WhatsApp",
    },
    botName: {
      title: "Nome do assistente",
      desc: "O nome que o bot usará para se apresentar aos seus hóspedes.",
      empty: "Nenhum nome atribuído",
      edit: "Editar",
      placeholder: "Ex.: Maria, Sofia, Assistente Virtual...",
      save: "Salvar",
    },
    faqs: {
      title: "Perguntas frequentes",
      desc: "Estas FAQs se aplicam a <strong>todas as unidades</strong> deste anúncio. O bot as usará para responder aos seus hóspedes.",
      add: "Nova FAQ",
      emptyText: "Você ainda não configurou nenhuma pergunta frequente.",
      addFirst: "+ Adicionar primeira FAQ",
      answerEmpty: "Sem resposta",
      editTitle: "Editar",
      deleteTitle: "Excluir",
      questionLabel: "Pergunta",
      answerLabel: "Resposta",
      questionPlaceholder: "Digite a pergunta...",
      answerPlaceholder: "Digite a resposta que o hóspede verá...",
      saveChanges: "Salvar alterações",
    },
    addModal: {
      title: "Nova pergunta frequente",
      questionLabel: "Pergunta",
      questionPlaceholder: "Ex.: A que horas é o check-in?",
      answerLabel: "Resposta",
      answerPlaceholder: "Ex.: O check-in é a partir das 15h. Se chegar antes, você pode deixar sua bagagem...",
      submit: "Adicionar FAQ",
    },
    deleteModal: {
      title: "Excluir pergunta",
      confirm: "Tem certeza de que deseja excluir esta FAQ?",
      deleting: "Excluindo...",
      submit: "Sim, excluir",
    },
    types: {
      apartment: "Apartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      room: "Quarto",
      studio: "Studio",
      default: "Acomodação",
    },
    toast: {
      botOn: "Bot ativado",
      botOff: "Bot desativado",
      botError: "Erro ao alterar o status do bot",
      otaOn: "IA de OTA ativada",
      otaOff: "IA de OTA desativada",
      otaError: "Erro ao alterar o status da IA de OTA",
      nameUpdated: "Nome do assistente atualizado",
      nameError: "Erro ao salvar o nome",
      faqAdded: "FAQ adicionada com sucesso",
      faqAddError: "Erro ao salvar a FAQ",
      faqUpdated: "FAQ atualizada",
      faqUpdateError: "Erro ao atualizar a FAQ",
      faqDeleted: "FAQ excluída",
      faqDeleteError: "Erro ao excluir a FAQ",
    },
  },

  listingIndex: {
    title: "Anúncios",
    subtitle: "Gerencie a configuração central de cada um dos seus anúncios.",
    countFiltered: "{shown} de {total} anúncios",
    count: "{count} anúncio | {count} anúncios",
    searchPlaceholder: "Buscar por nome, ID ou tipo…",
    clear: "Limpar",
    loadErrorTitle: "Não foi possível carregar as acomodações",
    retry: "Tentar novamente",
    emptyTitle: "Nenhum anúncio",
    emptyText: "Você ainda não tem nenhum anúncio cadastrado.",
    noResultsTitle: 'Nenhum resultado para "{query}"',
    noResultsText: "Tente outro nome, ID ou tipo de anúncio.",
    clearSearch: "Limpar busca",
    dragSearchHint: "Limpe a busca para reordenar",
    dragHint: "Arraste para reordenar",
    units: "{count} unidade | {count} unidades",
    botActiveTitle: "Bot GPT ativo",
    channelTitle: "Conectado ao Channex",
    icalTitle: "Sincronização iCal",
    editTitle: "Editar nome",
    modal: {
      title: "Editar nome do anúncio",
      nameLabel: "Nome do anúncio",
      namePlaceholder: "Ex.: Apartamentos Costa Sol",
      orderLabel: "Ordem do anúncio",
      info: "Um <strong>anúncio</strong> agrupa todas as propriedades que compartilham a mesma configuração, mensagens de boas-vindas e políticas. O nome que você definir aqui identificará o grupo no painel e nos canais de distribuição conectados.",
      cancel: "Cancelar",
      save: "Salvar alterações",
    },
    types: {
      apartment: "Apartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      room: "Quarto",
      studio: "Studio",
      default: "Acomodação",
    },
    toast: {
      connectionError: "Erro de conexão.",
      reorderSuccess: "Ordem atualizada com sucesso.",
      reorderError: "Não foi possível atualizar a ordem dos anúncios.",
      saveSuccess: "Anúncio atualizado com sucesso.",
      saveError: "Erro ao salvar o anúncio.",
    },
  },

  unitDetail: {
    back: "Voltar ao anúncio",
    eyebrow: "Unidade",
    save: "Salvar",
    cancel: "Cancelar",
    editNameTitle: "Editar nome da unidade",
    nameFallback: "Unidade",
    types: {
      apartment: "Apartamento",
      house: "Casa",
      villa: "Villa",
      hotel: "Hotel",
      camping: "Camping",
      room: "Quarto",
      studio: "Studio",
      default: "Acomodação",
    },
    deleteLink: "Excluir unidade...",
    dangerNoteBefore: "Remove a unidade do anúncio",
    dangerNoteAfter: "do WACheckin. Esta ação não pode ser desfeita.",
    cards: {
      description: { title: "Descrição", sub: "Detalhes da unidade" },
      capacity: { title: "Capacidade", sub: "Hóspedes e camas" },
      services: { title: "Equipamentos e comodidades", sub: "O que oferece, com fotos" },
      rules: { title: "Horários", sub: "Horários de check-in e check-out" },
      arrival: { title: "Instruções de chegada", sub: "Como chegar e entrar · com horário de envio" },
      smartlocks: { title: "Fechaduras e acesso", sub: "Como o hóspede entra" },
      checkout: { title: "Mensagem de check-out", sub: "Lembrete de check-out · modelo" },
      scheduled: { title: "Mensagens programadas", sub: "Mensagens só para esta unidade" },
      unitFaq: { title: "Perguntas e respostas", sub: "Específicas desta unidade para o agente", badge: "IA" },
      welcome: { title: "Mensagem de boas-vindas", sub: "Mensagem específica desta unidade" },
      stockExtra: {
        title: "Stock extra",
        subOff: "Desativado · recolhe reservas de outra unidade",
        subOn: "Reforça {name}",
        subOnGeneric: "Reforça outra unidade",
        badge: "Ativo",
      },
    },
    sections: {
      aiOnlyLabel: "Perguntas frequentes da unidade",
      aiOnlyDesc: "O agente as priorizará ao atender um hóspede hospedado nesta unidade.",
      specificLabel: "Configurações específicas desta unidade",
      detailLabel: "Detalhe esta unidade",
      detailDesc: "Informações adicionais que usamos para reservas diretas e para alimentar o Agente de IA.",
    },
    stockExtra: {
      title: "Stock extra",
      intro: "Na Booking ou no Airbnb pode ter um único anúncio com lotação para vários apartamentos: como só é possível mapear um, o canal envia todas essas reservas contra a mesma unidade e elas acumulam-se em overbooking.",
      how: "Se marcar esta unidade como stock extra de outra, as reservas que colidam com a principal ficam guardadas aqui e o canal é avisado para que lá também apareçam nesta unidade.",
      purpose: "É uma ferramenta de transição: liga-se para trazer o que já tinha vendido na OTA e desliga-se quando cada apartamento tiver o seu próprio anúncio.",
      loading: "A carregar...",
      activeLabel: "Reforça {name}",
      activeHint: "As reservas do canal que colidam com {name} ficam guardadas nesta unidade.",
      activeBadge: "Ativo",
      otherUnit: "outra unidade",
      warnTitle: "Não ligue isto se cada apartamento já tiver o seu próprio anúncio mapeado na OTA:",
      warnText: "aí o canal já envia cada reserva para a sua unidade e, com o stock extra ligado, uma reserva acabaria num apartamento que não é o que vendeu.",
      principalOf: "Outras unidades já se apoiam nesta:",
      chooseLabel: "Unidade principal",
      chooseDesc: "Escolha a unidade cujas reservas ficarão guardadas em «{unit}» quando colidirem entre si.",
      noCandidates: "Não há nenhuma outra unidade para reforçar neste anúncio.",
      activate: "Ativar o stock extra",
      change: "Mudar a unidade principal",
      saving: "A guardar...",
      removeBtn: "Retirar o stock extra",
      removeNote: "As reservas já guardadas aqui não são movidas: ficam nesta unidade.",
      errorCarga: "Não foi possível ler a configuração do stock extra. Se acabaste de atualizar, tenta recarregar a página.",
      reintentar: "Tentar de novo",
      toastLoadError: "Não foi possível carregar o stock extra.",
      toastSaveError: "Não foi possível guardar o stock extra.",
    },
    toast: {
      nameEmpty: "O nome não pode ficar vazio",
      nameUpdated: "Nome atualizado",
      nameError: "Não foi possível atualizar o nome",
    },
  },

  miCuenta: {},
};
